<form [formGroup]="form" (ngSubmit)="submit()">
    <h1 DraggableDialog mat-dialog-title>Varning!</h1>
    <mat-dialog-content>
      <p>Vill du verkligen ta bort <strong>{{data.userMapping.name}}</strong>?</p>
      <p>Borttagning kan ej ångras och relaterat data så som arbetspass och planerade och utförda aktiviteter kommer raderas.</p>

      <!--<mat-form-field>
        <input matInput formControlName="filename" placeholder="Enter filename">
      </mat-form-field>-->
    </mat-dialog-content>
    <hr />
    <mat-dialog-actions>
      <button mat-raised-button type="submit" color="warn">Ta bort</button>
      <button mat-raised-button type="button" color="primary" mat-dialog-close>Ångra</button>
    </mat-dialog-actions>

</form>
